<template>
  <div class="position-relative">
    <div
      v-if="canScrollUp"
      class="position-absolute w-100 top-shadow"
      :style="topShadowStyle"
    />
    
    <div
      ref="scrollContainer"
      class="scroll-shadow-content overflow-auto position-relative"
      :style="containerStyle"
      @scroll="handleScroll"
    >
      <slot />
    </div>
    
    <div
      v-if="canScrollDown"
      class="position-absolute w-100 bottom-shadow"
      :style="bottomShadowStyle"
    />
  </div>
</template>

<script>
export default {
  name: 'ScrollShadowContainer',
  props: {
    maxHeight: {
      type: String,
      default: '200px',
    },
    shadowHeight: {
      type: String,
      default: '8px',
    },
    shadowColor: {
      type: String,
      default: 'rgba(248, 249, 250, 0.9)'
    },
    scrollThreshold: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      scrollTop: 0,
      scrollHeight: 0,
      clientHeight: 0
    }
  },
  computed: {
    canScrollUp() {
      return this.scrollTop > 0
    },
    canScrollDown() {
      return this.scrollTop < this.scrollHeight - this.clientHeight - this.scrollThreshold
    },
    containerStyle() {
      return {
        'max-height': this.maxHeight
      }
    },
    shadowStyle() {
      return {
        height: this.shadowHeight,
        'z-index': '10',
        'pointer-events': 'none'
      }
    },
    topShadowStyle() {
      return {
        ...this.shadowStyle,
        top: '0',
        background: `linear-gradient(to bottom, ${this.shadowColor}, transparent)`
      }
    },
    bottomShadowStyle() {
      return {
        ...this.shadowStyle,
        bottom: '0',
        background: `linear-gradient(to top, ${this.shadowColor}, transparent)`
      }
    }
  },
  mounted() {
    this.$nextTick(this.updateScrollMetrics)
  },
  methods: {
    handleScroll() {
      this.updateScrollMetrics()
    },
    updateScrollMetrics() {
      const container = this.$refs.scrollContainer
      if (!container) {
        this.scrollTop = 0
        this.scrollHeight = 0
        this.clientHeight = 0
        return
      }

      const { scrollTop, scrollHeight, clientHeight } = container
      this.scrollTop = scrollTop
      this.scrollHeight = scrollHeight
      this.clientHeight = clientHeight
    }
  }
}
</script>